import { createFileRoute, Link } from "@tanstack/react-router";
import { useState, useMemo } from "react";
import { ChevronLeft } from "lucide-react";
import { PageHeader } from "@/components/app-shell";
import { CalcShell, Field, NumberInput, ResultCard, fmt } from "@/components/calculators/CalcShell";
import { AddToQuoteButton } from "@/components/calculators/AddToQuoteButton";
import { linesFromIsolasjon } from "@/components/calculators/lineMappers";
import { isolasjonCalc } from "@/domain/calculators/carpenter";

export const Route = createFileRoute("/_authenticated/calculations/carpenter/isolasjon")({
  component: IsolasjonPage,
});

function IsolasjonPage() {
  const [area, setArea] = useState<number | "">("");
  const [tykkelse, setTykkelse] = useState<number | "">(200);
  const [perPakke, setPerPakke] = useState<number | "">(5.4);
  const [spill, setSpill] = useState<number | "">(5);

  const r = useMemo(() => {
    if (area === "" || tykkelse === "" || perPakke === "") return null;
    return isolasjonCalc({
      area_m2: Number(area),
      tykkelse_mm: Number(tykkelse),
      m2_per_pakke: Number(perPakke),
      spill_pct: spill === "" ? undefined : Number(spill),
    });
  }, [area, tykkelse, perPakke, spill]);

  return (
    <>
      <Link to="/calculations" className="mb-4 inline-flex items-center text-sm text-muted-foreground hover:text-foreground">
        <ChevronLeft className="h-4 w-4" /> Beregninger
      </Link>
      <PageHeader title="Isolasjon" subtitle="Beregn antall pakker isolasjon." />
      <CalcShell
        title="Inndata"
        result={r ? (
          <>
            <ResultCard
            title="Materialbehov"
            rows={[
              { label: "Antall pakker", value: `${fmt(r.pakker, 0)} stk`, strong: true },
              { label: "Volum",          value: `${fmt(r.volum_m3, 2)} m³` },
            ]}
            note="Sjekk m² per pakke på produktdatablad – varierer med tykkelse."
          />
            <div className="mt-3 flex justify-end">
              <AddToQuoteButton sourceLabel={`Isolasjon`} lines={linesFromIsolasjon(r, Number(tykkelse))} defaultLaborHours={Math.max(0, Math.round((Number(area) * 0.2) * 10) / 10)} />
            </div>
          </>
        ) : <div className="card p-5 text-sm text-muted-foreground">Fyll inn areal, tykkelse og m² per pakke.</div>}
      >
        <Field label="Areal" unit="m²"><NumberInput value={area} onChange={setArea} /></Field>
        <Field label="Tykkelse" unit="mm"><NumberInput value={tykkelse} onChange={setTykkelse} /></Field>
        <Field label="m² per pakke" unit="m²"><NumberInput value={perPakke} onChange={setPerPakke} /></Field>
        <Field label="Svinn" unit="%"><NumberInput value={spill} onChange={setSpill} /></Field>
      </CalcShell>
    </>
  );
}
